import { Icon } from "@iconify/react";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const ViewProductAffiliate = ({ affiliatesProducts }) => {
  const navigate = useNavigate();

  const handleClick = useCallback((affiliate) => {
    // Navegar para a página ESPECÍFICA PARA AFILIADOS usando o ID do produto
    if (affiliate.product?.id) {
      navigate(`/affiliate/products/${affiliate.product.id}`);
    } else {
      console.error('❌ ViewProductAffiliate - Produto sem ID:', affiliate);
      // Fallback: mostrar mensagem de erro
      alert('Erro: Produto não encontrado');
    }
  }, [navigate]);

  // Se não há produtos que promove
  if (!affiliatesProducts || affiliatesProducts.length === 0) {
    return (
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="text-center py-5">
            <Icon icon="mdi:megaphone" className="fs-1 text-muted mb-3" />
            <h6 className="text-muted">Nenhum produto promovido encontrado</h6>
            <p className="text-muted">
              Você ainda não promove nenhum produto como afiliado.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h6 className="mb-0">Produtos que Promovo ({affiliatesProducts.length})</h6>
        </div>
        
        <div className="row gy-4">
          {affiliatesProducts.map((affiliate, index) => {
            return (
            <div className="col-xxl-3 col-md-6 user-grid-card" key={affiliate.id || index}>
              <div className="position-relative border radius-16 overflow-hidden h-100 bg-white shadow-sm hover-shadow-lg transition-all">
                {/* Imagem de fundo */}
                <div 
                  className="position-relative bg-light d-flex align-items-center justify-content-center overflow-hidden"
                  style={{ height: "150px" }}
                >
                  <img
                    src={affiliate.product?.image || "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik02MCA0MEM2Ni42MjcgNDAgNzIgNDUuMzcyIDcyIDUyQzcyIDU4LjYyNyA2Ni42MjcgNjQgNjAgNjRDNzMuMzcyIDY0IDU4LjYyNyA2NCA1MiA2NEM1MiA1OC42MjcgNTIuMzcyIDUyIDUyIDUyQzUyIDQ1LjM3MiA1Ny4zNzIgNDAgNjAgNDBaIiBmaWxsPSIjOUNBM0FGIi8+Cjx0ZXh0IHg9IjYwIiB5PSI4MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzZCNzI4MCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIj5Qcm9kdXRvPC90ZXh0Pgo8L3N2Zz4K"}
                    alt={affiliate.product?.name || 'Produto'}
                    className="w-100 h-100 object-fit-cover"
                    style={{ filter: 'brightness(0.9)' }}
                    onError={(e) => {
                      e.target.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik02MCA0MEM2Ni42MjcgNDAgNzIgNDUuMzcyIDcyIDUyQzcyIDU4LjYyNyA2Ni42MjcgNjQgNjAgNjRDNzMuMzcyIDY0IDU4LjYyNyA2NCA1MiA2NEM1MiA1OC42MjcgNTIuMzcyIDUyIDUyIDUyQzUyIDQ1LjM3MiA1Ny4zNzIgNDAgNjAgNDBaIiBmaWxsPSIjOUNBM0FGIi8+Cjx0ZXh0IHg9IjYwIiB5PSI4MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzZCNzI4MCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIj5Qcm9kdXRvPC90ZXh0Pgo8L3N2Zz4K";
                    }}
                  />
                  
                  {/* Badge de status */}
                  <div className="position-absolute top-12 end-12">
                    <span className={`badge ${
                      affiliate.status === 'approved' ? 'bg-success' :
                      affiliate.status === 'pending' ? 'bg-warning' :
                      'bg-secondary'
                    } text-white px-8 py-4 text-xs fw-medium radius-6`}>
                      {affiliate.status === 'approved' ? 'Aprovado' :
                       affiliate.status === 'pending' ? 'Pendente' :
                       'Inativo'}
                    </span>
                  </div>
                </div>
                
                {/* Conteúdo do card */}
                <div className="p-16">
                  {/* Nome do produto */}
                  <div className="mb-12">
                    <h6 className="text-md mb-6 fw-semibold line-height-1-3" title={affiliate.product?.name}>
                      {affiliate.product?.name || 'Produto sem nome'}
                    </h6>
                    
                    {/* Código do produto */}
                    <div className="d-flex align-items-center gap-2 mb-8">
                      <Icon icon="solar:hashtag-linear" className="text-xs text-secondary-light" />
                      <span className="text-xs text-secondary-light fw-medium font-monospace">
                        {affiliate.product?.product_code || affiliate.product?.id || 'N/A'}
                      </span>
                    </div>
                  </div>

                                      {/* Informações do produto */}
                    <div className="mb-16">
                      <div className="d-flex align-items-center gap-2 mb-8">
                        <Icon icon="mdi:account" className="text-xs text-secondary-light" />
                        <span className="text-xs text-secondary-light">
                          Produtor: {affiliate.product?.producer_name || 'N/A'}
                        </span>
                      </div>

                      {/* Gerente (se afiliado de gerente) */}
                      {affiliate.manager_name && (
                        <div className="d-flex align-items-center gap-2 mb-8">
                          <Icon icon="mdi:account-tie" className="text-xs text-info" />
                          <span className="text-xs text-info">
                            Gerente: {affiliate.manager_name}
                          </span>
                        </div>
                      )}

                      {/* Taxa de comissão */}
                      <div className="d-flex align-items-center gap-2 mb-8">
                        <Icon icon="mdi:percent" className="text-xs text-secondary-light" />
                        <span className="text-xs text-secondary-light">
                          Comissão: {affiliate.commission_rate || 0}%
                        </span>
                      </div>

                      {/* Status da afiliação */}
                      <div className="d-flex align-items-center gap-2 mb-8">
                        <Icon icon="mdi:calendar" className="text-xs text-secondary-light" />
                        <span className="text-xs text-secondary-light">
                          Afiliado desde: {new Date(affiliate.createdAt).toLocaleDateString('pt-BR')}
                        </span>
                      </div>
                    </div>

                  {/* Botão de ação */}
                  <button
                    onClick={() => handleClick(affiliate)}
                    className="bg-primary-50 text-primary-600 bg-hover-primary-600 hover-text-white p-10 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center justify-content-center mt-16 fw-medium gap-2 w-100 transition-all"
                  >
                    Ver Produto
                    <Icon
                      icon="solar:eye-linear"
                      className="icon text-xl line-height-1"
                    />
                  </button>
                </div>
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ViewProductAffiliate;
